var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'width': '16px',
'height': '11px',
'viewBox': '0 0 16 11',
'version': '1.1',
'xmlns': 'http://www.w3.org/2000/svg',
'xmlnsXlink': 'http://www.w3.org/1999/xlink',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <!-- Generator: Sketch 45.2 (43514) - http://www.bohemiancoding.com/sketch --> <title>mail</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"SUPER-ADMIN\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"A-5.5-Candidate-Report-after-filter\" transform=\"translate(-190.000000, -696.000000)\" fill-rule=\"nonzero\" fill=\"#9E9E9E\"> <g id=\"Group-8\" transform=\"translate(188.000000, 573.000000)\"> <g id=\"mail\" transform=\"translate(2.000000, 123.000000)\"> <path d=\"M0,0 L0,0.0182449866 L7.58991444,4.57949164 L15.1798289,0.0182449866 L15.1798289,0 L0,0 Z M0,1.38661898 L0,10.5091123 L15.1798289,10.5091123 L15.1798289,1.38661898 L7.58991444,5.92962066 L0,1.38661898 Z\" id=\"Shape\"></path> </g> </g> </g> </g> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./node_modules/dk-ui-lib/assets/mail.svg